//Search
export const IDI_PROJECT_SEARCH_START_LOADING = "IDI_PROJECT_SEARCH_START_LOADING";
export const IDI_PROJECT_SEARCH_END_LOADING = "IDI_PROJECT_SEARCH_END_LOADING";
export const IDI_PROJECT_SEARCH_LOADED = "IDI_PROJECT_SEARCH_LOADED";
export const SET_IDI_PROJECT_FILTER = "SET_IDI_PROJECT_FILTER";

//Edit
export const IDI_PROJECT_START_LOADING = "IDI_PROJECT_START_LOADING";
export const IDI_PROJECT_END_LOADING = "IDI_PROJECT_END_LOADING";
export const IDI_PROJECT_LOADED = "IDI_PROJECT_LOADED";